module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "value": _vm.visible,
      "class-name": "ai-drawer-modal",
      "width": "520",
      "mask-closable": false,
      "closable": true,
      "title": "AI 助手"
    },
    on: {
      "on-visible-change": _vm.onVisibleChange,
      "on-cancel": _vm.closeDrawer
    }
  }, [_c('div', {
    staticClass: "ai-drawer-body"
  }, [_c('Card', {
    staticClass: "ai-block",
    attrs: {
      "dis-hover": ""
    }
  }, [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("任务")]), _vm._v(" "), _c('RadioGroup', {
    on: {
      "on-change": _vm.onTaskTypeChange
    },
    model: {
      value: (_vm.taskType),
      callback: function($$v) {
        _vm.taskType = $$v
      },
      expression: "taskType"
    }
  }, _vm._l((_vm.taskOptions), function(opt) {
    return _c('Radio', {
      key: opt.value,
      attrs: {
        "label": opt.value
      }
    }, [_vm._v(_vm._s(opt.label))])
  }), 1), _vm._v(" "), (_vm.taskType === 'ADVISOR_RENEWAL') ? _c('p', {
    staticClass: "ai-hint"
  }, [_vm._v("仅内部沟通，不向家长发送，不催费")]) : _vm._e()], 1), _vm._v(" "), _c('Card', {
    staticClass: "ai-block",
    attrs: {
      "dis-hover": ""
    }
  }, [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("事实")]), _vm._v(" "), (_vm.preparing) ? _c('p', {
    staticClass: "ai-muted"
  }, [_vm._v("正在准备事实…")]) : (!_vm.uid) ? _c('p', {
    staticClass: "ai-error"
  }, [_vm._v(_vm._s(_vm.missingIdText))]) : (_vm.prepareFailed) ? _c('p', {
    staticClass: "ai-error"
  }, [_vm._v(_vm._s(_vm.displayError))]) : (_vm.factRows.length) ? _c('div', _vm._l((_vm.factRows), function(row) {
    return _c('div', {
      key: row.key,
      staticClass: "ai-fact-row"
    }, [_c('Checkbox', {
      attrs: {
        "value": _vm.isFactIncluded(row.key)
      },
      on: {
        "on-change": function($event) {
          return _vm.onFactCheck(row.key, $event)
        }
      }
    }, [_c('span', {
      staticClass: "ai-fact-key"
    }, [_vm._v(_vm._s(row.key))])]), _vm._v(" "), _c('span', {
      staticClass: "ai-fact-value"
    }, [_vm._v(_vm._s(row.display))]), _vm._v(" "), (row.table) ? _c('span', {
      staticClass: "ai-fact-source"
    }, [_vm._v("来源：" + _vm._s(row.table))]) : _vm._e()], 1)
  }), 0) : _c('p', {
    staticClass: "ai-muted"
  }, [_vm._v("暂无事实")])]), _vm._v(" "), _c('Card', {
    staticClass: "ai-block",
    attrs: {
      "dis-hover": ""
    }
  }, [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("结果")]), _vm._v(" "), _c('div', {
    staticClass: "ai-result-toolbar"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "loading": _vm.generating,
      "disabled": !_vm.canGenerate
    },
    on: {
      "click": _vm.onGenerate
    }
  }, [_vm._v("生成")]), _vm._v(" "), (_vm.isMarket) ? _c('span', {
    staticClass: "ai-hint"
  }, [_vm._v("市场角色仅生成，不写回。")]) : _vm._e()], 1), _vm._v(" "), (!_vm.uid) ? _c('p', {
    staticClass: "ai-error"
  }, [_vm._v(_vm._s(_vm.missingIdText))]) : (_vm.resultError) ? _c('p', {
    staticClass: "ai-error"
  }, [_vm._v(_vm._s(_vm.displayError))]) : (_vm.output) ? _c('div', {
    staticClass: "ai-result"
  }, [(_vm.taskType === 'SALES_FOLLOWUP') ? _c('div', [_c('p', [_c('b', [_vm._v("摘要")]), _vm._v("：" + _vm._s(_vm.output.summary))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("需求")]), _vm._v("：" + _vm._s(_vm.formatList(_vm.output.needs)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("已知事实")]), _vm._v("：" + _vm._s(_vm.formatValue(_vm.output.knownFacts)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("待确认")]), _vm._v("：" + _vm._s(_vm.formatList(_vm.output.missingQuestions)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("意向")]), _vm._v("：" + _vm._s(_vm.output.intentLevel))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("下一步")]), _vm._v("：" + _vm._s(_vm.formatValue(_vm.output.nextAction)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("回复草稿")]), _vm._v("：" + _vm._s(_vm.output.replyDraft))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("提醒")]), _vm._v("：" + _vm._s(_vm.formatList(_vm.output.warnings)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("跟进文案")]), _vm._v("：" + _vm._s(_vm.output.followUpText))])]) : (_vm.taskType === 'SALES_CALL_ANALYSIS') ? _c('div', [_c('p', [_c('b', [_vm._v("意向")]), _vm._v("：" + _vm._s(_vm.output.intentLevel) + " " + _vm._s(_vm.output.intentReason))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("成交")]), _vm._v("：" + _vm._s(_vm.dealLabel(_vm.output.dealLikelihood)) + " " + _vm._s(_vm.output.dealReason))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("销售质量")]), _vm._v("：" + _vm._s(_vm.output.qualityScore) + " " + _vm._s(_vm.formatList(_vm.output.qualityReasons)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("结论")]), _vm._v("：" + _vm._s(_vm.output.followUpText))])]) : (_vm.taskType === 'ADVISOR_AFTER_CLASS') ? _c('div', [_c('p', [_c('b', [_vm._v("家长反馈")]), _vm._v("：" + _vm._s(_vm.output.parentFeedback))])]) : (_vm.taskType === 'ADVISOR_WEEKLY') ? _c('div', [_c('p', [_c('b', [_vm._v("总览")]), _vm._v("：" + _vm._s(_vm.output.overview))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("亮点")]), _vm._v("：" + _vm._s(_vm.formatList(_vm.output.highlights)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("待复习")]), _vm._v("：" + _vm._s(_vm.output.toReview))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("家庭建议")]), _vm._v("：" + _vm._s(_vm.formatList(_vm.output.homeAdvice)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("下阶段目标")]), _vm._v("：" + _vm._s(_vm.output.nextGoal))])]) : (_vm.taskType === 'ADVISOR_RENEWAL') ? _c('div', [_c('p', [_c('b', [_vm._v("内部提纲")]), _vm._v("：" + _vm._s(_vm.output.internalOutline))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("风险标记")]), _vm._v("：" + _vm._s(_vm.formatList(_vm.output.riskFlags)))])]) : (_vm.taskType === 'RISK_EXPLAIN' || _vm.taskType === 'TCH_RISK_EXPLAIN') ? _c('div', [_c('p', {
    staticClass: "ai-hint"
  }, [_vm._v("分数由规则日批计算，模型不重算")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("解释")]), _vm._v("：" + _vm._s(_vm.output.explanation))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("建议动作")]), _vm._v("：" + _vm._s(_vm.actionLabel(_vm.output.suggestedAction)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("沟通要点")]), _vm._v("：" + _vm._s(_vm.formatList(_vm.output.talkingPoints)))])]) : _vm._e(), _vm._v(" "), _c('Collapse', {
    staticClass: "ai-raw-json"
  }, [_c('Panel', {
    attrs: {
      "name": "raw"
    }
  }, [_vm._v("\n            原始 JSON\n            "), _c('pre', {
    staticClass: "ai-pre",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v(_vm._s(_vm.formatJson(_vm.output)))])])], 1)], 1) : _c('p', {
    staticClass: "ai-muted"
  }, [_vm._v("点击生成后展示结果")])]), _vm._v(" "), _c('Card', {
    staticClass: "ai-block",
    attrs: {
      "dis-hover": ""
    }
  }, [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("确认")]), _vm._v(" "), _c('p', {
    staticClass: "ai-writeback-hint"
  }, [_vm._v(_vm._s(_vm.writebackHint))]), _vm._v(" "), _c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 5,
      "disabled": _vm.confirmReadOnly,
      "placeholder": "确认写入的文案"
    },
    model: {
      value: (_vm.editedText),
      callback: function($$v) {
        _vm.editedText = $$v
      },
      expression: "editedText"
    }
  }), _vm._v(" "), (!_vm.isMarket) ? _c('div', {
    staticClass: "ai-confirm-btns"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "loading": _vm.approving || _vm.executing,
      "disabled": !_vm.canConfirm
    },
    on: {
      "click": _vm.onConfirmWriteback
    }
  }, [_vm._v("确认并写回")]), _vm._v(" "), _c('Button', {
    attrs: {
      "size": "small",
      "disabled": !_vm.canAbandon
    },
    on: {
      "click": _vm.onAbandon
    }
  }, [_vm._v("放弃")])], 1) : _vm._e()], 1), _vm._v(" "), _c('Card', {
    staticClass: "ai-block",
    attrs: {
      "dis-hover": ""
    }
  }, [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("反馈")]), _vm._v(" "), _c('div', {
    staticClass: "ai-feedback-btns"
  }, [_c('Button', {
    attrs: {
      "size": "small",
      "disabled": !_vm.canFeedback
    },
    on: {
      "click": function($event) {
        return _vm.onFeedback(1)
      }
    }
  }, [_vm._v("采用")]), _vm._v(" "), _c('Button', {
    attrs: {
      "size": "small",
      "disabled": !_vm.canFeedback
    },
    on: {
      "click": function($event) {
        return _vm.onFeedback(2)
      }
    }
  }, [_vm._v("修改后采用")]), _vm._v(" "), _c('Button', {
    attrs: {
      "size": "small",
      "disabled": !_vm.canFeedback
    },
    on: {
      "click": function($event) {
        return _vm.onFeedback(0)
      }
    }
  }, [_vm._v("不采用")])], 1), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "180px",
      "margin-top": "8px"
    },
    attrs: {
      "clearable": "",
      "placeholder": "问题类型（可选）"
    },
    model: {
      value: (_vm.feedbackIssueType),
      callback: function($$v) {
        _vm.feedbackIssueType = $$v
      },
      expression: "feedbackIssueType"
    }
  }, [_c('Option', {
    attrs: {
      "value": "FACT"
    }
  }, [_vm._v("事实有误")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "TONE"
    }
  }, [_vm._v("语气不当")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "POLICY"
    }
  }, [_vm._v("违反规范")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "OTHER"
    }
  }, [_vm._v("其他")])], 1), _vm._v(" "), _c('Input', {
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "补充说明（可选）"
    },
    model: {
      value: (_vm.feedbackComment),
      callback: function($$v) {
        _vm.feedbackComment = $$v
      },
      expression: "feedbackComment"
    }
  })], 1), _vm._v(" "), _c('Card', {
    staticClass: "ai-block",
    attrs: {
      "dis-hover": ""
    }
  }, [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("历史")]), _vm._v(" "), (_vm.historyLoading) ? _c('p', {
    staticClass: "ai-muted"
  }, [_vm._v("加载中…")]) : (!_vm.history.length) ? _c('p', {
    staticClass: "ai-muted"
  }, [_vm._v("暂无历史")]) : _c('div', {
    staticClass: "ai-history"
  }, [_c('p', {
    staticClass: "ai-hint"
  }, [_vm._v("点击一条可把该次结果填回上方")]), _vm._v(" "), _vm._l((_vm.history), function(item) {
    return _c('div', {
      key: _vm.historyKey(item),
      staticClass: "ai-history-item",
      class: {
        'ai-history-item-active': _vm.historyKey(item) === _vm.runId
      },
      on: {
        "click": function($event) {
          return _vm.onHistoryClick(item)
        }
      }
    }, [_c('span', {
      staticClass: "ai-history-time"
    }, [_vm._v(_vm._s(_vm.historyTime(item)))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.historyTaskLabel(item)))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.historyStatusLabel(item)))])])
  })], 2)])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": _vm.closeDrawer
    }
  }, [_vm._v("关闭")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62fc72cd","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ai/AiDrawer.vue
// module id = 1836
// module chunks = 8